import { compress } from "lz-string";

export const HeliumEncryption = {
  encrypt(json: object): string {
    const stringifiedJson = JSON.stringify(json);

    return compress(stringifiedJson);
  },
};
